import React from 'react';
import { useSelector } from 'react-redux';
import Heading from '@starbucks-web/pattern-library/lib/components/heading';
import { capitalize } from 'lodash';
import { FormattedMessage } from 'react-intl';

import messages from './messages';
import BentoBox from '../bento-box';
import { getCompartmentsByLevel } from '../shared/compartments-config';
import { configImagesUrlSelector } from 'shared/app/state/selectors/config';
import { STATUS_LEVELS } from '../shared/constants';

import '../shared/styles/color-palette.css';
import UniversalBenefitBox from '../universal-benefit-box';

const StatusLevelBenefits = ({ level = STATUS_LEVELS.GREEN }) => {
  const imageBaseUrl = useSelector(configImagesUrlSelector);

  const getCompartments = () => {
    if (!imageBaseUrl) {
      return [];
    }
    return getCompartmentsByLevel(level, imageBaseUrl);
  };

  const compartments = getCompartments();

  return (
    <section className="my9 flex flex-column items-center">
      <Heading
        className="text-center text-bold pb4 color-greenOnPrimary"
        data-e2e={`status-level-benefits-${level.toLowerCase()}`}
        size="xl"
        tagName="h2"
      >
        <FormattedMessage
          {...messages.statusLevelBenefitsHeading}
          values={{ level: capitalize(level) }}
        />
      </Heading>
      {compartments.length > 0 && (
        <BentoBox
          compartments={compartments}
          containerClasses="max-width-containerMaxWidth mx-auto py5 md-py9"
          data-e2e={`${level.toLowerCase()}-status-benefits`}
          rewardsLevel={level}
        />
      )}
      <UniversalBenefitBox />
    </section>
  );
};

export default StatusLevelBenefits;
